export default __webpack_public_path__ + "static/media/image50.cada103c.png";